import React, { useState, useEffect } from 'react';
export var TouchableControlContext = /*#__PURE__*/React.createContext({
  turnOffTouchability: false
});
export var TouchableControlConsumer = TouchableControlContext.Consumer;
export var useTouchableControl = () => React.useContext(TouchableControlContext);
var TouchableControlProvider = _ref => {
  var {
    turnOffTouchability: turnOffTouchabilityProp = false,
    touchablesInteractiveState: touchablesInteractiveStateProp,
    children
  } = _ref;
  var [turnOffTouchability, setTurnOffTouchability] = useState(turnOffTouchabilityProp);
  var [touchablesInteractiveState, setTouchablesInteractiveState] = useState(touchablesInteractiveStateProp);
  useEffect(() => {
    setTurnOffTouchability(turnOffTouchabilityProp);
  }, [turnOffTouchabilityProp]);
  useEffect(() => {
    setTouchablesInteractiveState(touchablesInteractiveStateProp);
  }, [touchablesInteractiveStateProp]);
  return /*#__PURE__*/React.createElement(TouchableControlContext.Provider, {
    value: {
      turnOffTouchability,
      touchablesInteractiveState
    }
  }, children);
};
TouchableControlProvider.displayName = 'TouchableControlProvider';
export { TouchableControlProvider };
//# sourceMappingURL=index.js.map